"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _classnames2 = _interopRequireDefault(require("classnames"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var getChildChecked = function getChildChecked(children) {
  var checkedValue = [];

  _react.default.Children.map(children, function (element) {
    if (_react.default.isValidElement(element) && element.props && element.props.checked) {
      checkedValue.push(element.props.value);
    }
  });

  return checkedValue;
};

var getValue = function getValue(props, defaultValue) {
  if (typeof props.value !== 'undefined') {
    return props.value;
  }

  if (typeof props.defaultValue !== 'undefined') {
    return props.defaultValue;
  }

  if (getChildChecked(props.children).length > 0) {
    return getChildChecked(props.children);
  }

  return defaultValue;
};

var CheckboxGroup =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(CheckboxGroup, _PureComponent);

  function CheckboxGroup(props) {
    var _this;

    _classCallCheck(this, CheckboxGroup);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(CheckboxGroup).call(this, props));

    _this.onChildChange = function (value) {
      var valueState = _this.state.value;
      var values = valueState.slice();
      var index = values.indexOf(value);

      if (index < 0) {
        values.push(value);
      } else {
        values.splice(index, 1);
      }

      _this.setState({
        value: values
      });

      var onChange = _this.props.onChange;

      if (typeof onChange === 'function') {
        onChange(values);
      }
    };

    _this.state = {
      value: getValue(props, [])
    };
    return _this;
  }

  _createClass(CheckboxGroup, [{
    key: "render",
    value: function render() {
      var _this2 = this,
          _classnames;

      var _this$props = this.props,
          prefixCls = _this$props.prefixCls,
          className = _this$props.className,
          size = _this$props.size,
          shape = _this$props.shape,
          type = _this$props.type,
          block = _this$props.block,
          disabled = _this$props.disabled,
          compact = _this$props.compact,
          ghost = _this$props.ghost,
          children = _this$props.children;
      var value = this.state.value;

      var items = _react.default.Children.map(children, function (element, index) {
        if ((0, _react.isValidElement)(element)) {
          return (0, _react.cloneElement)(element, {
            key: index,
            type: type,
            shape: shape,
            block: block || element.props.block,
            disabled: disabled || element.props.disabled,
            checked: value.indexOf(element.props.value) > -1,
            onChange: function onChange(checked) {
              typeof element.props.onChange === 'function' && element.props.onChange(checked);

              _this2.onChildChange(element.props.value);
            }
          });
        }

        return null;
      });

      var cls = (0, _classnames2.default)(prefixCls, className, (_classnames = {}, _defineProperty(_classnames, "".concat(prefixCls, "--").concat(type), !!type), _defineProperty(_classnames, "".concat(prefixCls, "--").concat(size), !!size), _defineProperty(_classnames, "".concat(prefixCls, "--").concat(shape), !!shape), _defineProperty(_classnames, "".concat(prefixCls, "--block"), block), _defineProperty(_classnames, "".concat(prefixCls, "--disabled"), disabled), _defineProperty(_classnames, "".concat(prefixCls, "--compact"), compact), _defineProperty(_classnames, "".concat(prefixCls, "--ghost"), ghost), _classnames));
      return _react.default.createElement("div", {
        className: cls
      }, _react.default.createElement("div", {
        className: "".concat(prefixCls, "__inner")
      }, items));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps) {
      if ('value' in nextProps) {
        return {
          value: getValue(nextProps, [])
        };
      }

      return null;
    }
  }]);

  return CheckboxGroup;
}(_react.PureComponent);

exports.default = CheckboxGroup;
CheckboxGroup.displayName = 'CheckboxGroup';
CheckboxGroup.defaultProps = {
  prefixCls: 'za-checkbox-group',
  shape: 'radius',
  block: false,
  disabled: false,
  compact: false,
  ghost: false,
  size: 'xs'
};